export const getCurrentProject = state => state.projects.currentProject;
export const getProjectLoading = state => state.projects.projectsLoadingStatus;
export const getCurrentKp = state => state.kp.currentKp;
export const getKpLoading = state => state.kp.kpLoadingStatus;
export const getCurrentSubKp = state => state.kp.currentSubKp;
